/*
 * @Author       : yiyang
 * @Date         : 2020-10-27 15:29:10
 * @LastEditors  : yiyang
 * @LastEditTime : 2020-11-05 14:50:17
 * @PRD          : 
 * @Description  : 
 * @FilePath     : /work/yit_fe_shangbo/src/layouts/GeneralLayout/index.js
 * @URL          : 
 */
import './index.css'
import React, { useEffect } from 'react'
import NETImage from 'components/net-image'

/**
 * 首页布局
 */
export default function GeneralLayout(props) {
    let { children, pageInfo = {}, pageBanner, className, ...otherProps } = props;
    useEffect(() => {
        document.title = pageInfo.title || '上海博物馆';
    })

    return (
        <section className={`General__layout ${className}`} {...otherProps} style={pageInfo.style}>
            {pageBanner && <NETImage
                src={pageBanner.imgUrl}
                useAutoHeight
                startHeight={pageBanner.height || 120}
            />}
            <div className='General__layout-content--wrapper'>
                <div className='General__layout-content'>
                    {children}
                </div>
            </div>
            {pageInfo.showBottom && <div className='GeneralList__layout-bottom'>
                <span>上海博物馆</span>
            </div>}
        </section>
    )
}